import React, {useState, useEffect} from 'react';
import {observer} from 'mobx-react';
import {Range} from 'react-range';
import priceRangeStore from './price-range-store';

const PriceRangeSlider = observer(() => {
    const range = priceRangeStore.range;
    const [localMin, setLocalMin] = useState(range[0]);
    const [localMax, setLocalMax] = useState(range[1]);

    useEffect(() => {
        setLocalMin(range[0]);
        setLocalMax(range[1]);
    }, [range]);

    return (
        <div>
            <strong className="d-inline-block">Price Range Filter</strong>
            <div>
                <input
                    type="number"
                    id="min-price"
                    min={priceRangeStore.min}
                    max={priceRangeStore.max}
                    value={localMin}
                    onChange={e => setLocalMin(+e.target.value)}
                    onBlur={() => priceRangeStore.setMinValue(+localMin)}
                    aria-label="Minimum price"
                />
                <span> &minus; </span>
                <input
                    type="number"
                    id="max-price"
                    min={priceRangeStore.min}
                    max={priceRangeStore.max}
                    value={localMax}
                    onChange={e => setLocalMax(+e.target.value)}
                    onBlur={() => priceRangeStore.setMaxValue(+localMax)}
                    aria-label="Maximum price"
                />
            </div>
            <Range
                step={1}
                min={priceRangeStore.min}
                max={priceRangeStore.max}
                values={priceRangeStore.range}
                onChange={range => priceRangeStore.setPriceRange(range)}
                renderTrack={({props, children}) => (
                    <div
                        {...props}
                        style={{...props.style}}
                        className="slider"
                    >
                        {children}
                    </div>
                )}
                renderThumb={({props}) => (
                    <div
                        {...props}
                        style={{...props.style}}
                        className="thumb"
                    />
                )}
            />
        </div>
    );
});

export default PriceRangeSlider;
